/**
 * Web stub for native social sign-in. Google/Apple native modules don't run in
 * the web bundle, and web login uses the email code path — so the buttons are
 * hidden on web (see login.tsx) and these throw if ever called.
 */
export const googleAvailable = false;
export const appleAvailable = false;

export async function googleIdToken(): Promise<string> {
  throw { error: 'Use email sign-in on the web' };
}

export async function appleCredential(): Promise<{ identityToken: string; nonce: string; fullName?: string }> {
  throw { error: 'Use email sign-in on the web' };
}
